export default "__VITE_ASSET__HHP5iEVp__"